<div class="page">
  <app-page-header page-title="companies.informativeNoteList.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'companies.informativeNoteList.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'companies.informativeNoteList.listTab.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6"></div> <!-- /.col-12.col-md-6 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block" [disabled]="exportIsLoading"
                    *ngIf="loggedUserPermissions.includes('canExportCompanies')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-6 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="name"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ paginator.pageIndex * paginator.pageSize + i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="filters.name" [maxlength]="searchMaxLength">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter('name')"
                        class="reset-input-icon" *ngIf="filters.name.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.email' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.email }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="filters.email" [maxlength]="searchMaxLength">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter('email')"
                        class="reset-input-icon" *ngIf="filters.email.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="pec">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.pec' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.pec }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="filters.pec" [maxlength]="searchMaxLength">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter('pec')"
                        class="reset-input-icon" *ngIf="filters.pec.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="phone">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.phone' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="filters.phone" [maxlength]="searchMaxLength">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter('phone')"
                        class="reset-input-icon" *ngIf="filters.phone.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="col-width col-width-10 text-right pr-5">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <a mat-raised-button color="primary" [routerLink]="'../detail/' + element._id"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator #paginator [length]="dataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->
